import isFunction from './isFunction';

const NON_FOUND_IDX = -1;

/**
 * Find index of element by condition
 * @export
 * @param {Array} array array
 * @param {Function|Object} condition some condition
 * @returns {Number} index of object, or `-1` if cond not returned true
 */
export default function findIndex(array, condition) {
   const cond = isFunction(condition) ? condition : (c) => c === condition;
   for (let i = 0; i < array.length; i++) {
      if (cond(array[i])) {
         return i;
      }
   }
   return NON_FOUND_IDX;
}
